import React from 'react';
import { getQuestionPoolStats } from '../enhancedCategories';
import { FEATURE_FLAGS } from '../../../engine/enhancers/questionEnhancer';

const EnhancementStats = () => {
  const stats = getQuestionPoolStats();
  
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Assessment Engine Status</h3>
        <div className={`px-3 py-1 rounded-full text-sm font-medium ${
          FEATURE_FLAGS.AI_SELECTION 
            ? 'bg-green-100 text-green-800' 
            : 'bg-gray-100 text-gray-800'
        }`}>
          {FEATURE_FLAGS.AI_SELECTION ? '🤖 AI Enhanced' : '📝 Standard Mode'}
        </div>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-indigo-600">{stats.totalCategories}</div>
          <div className="text-sm text-gray-600">Categories</div>
        </div>
        
        <div className="text-center">
          <div className="text-2xl font-bold text-indigo-600">{stats.totalBaseQuestions}</div>
          <div className="text-sm text-gray-600">Base Questions</div>
        </div>
        
        {FEATURE_FLAGS.AI_SELECTION && (
          <>
            <div className="text-center">
              <div className="text-2xl font-bold text-purple-600">{stats.totalEnhancedPool}</div>
              <div className="text-sm text-gray-600">AI Pool Size</div>
            </div>
            
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600">
                {Math.round((stats.totalEnhancedPool / stats.totalBaseQuestions) * 100) / 100}x
              </div>
              <div className="text-sm text-gray-600">Expansion Factor</div>
            </div>
          </>
        )}
        
        {!FEATURE_FLAGS.AI_SELECTION && (
          <>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-400">350</div>
              <div className="text-sm text-gray-600">Total Questions</div>
            </div>
            
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-400">v{stats.enhancementVersion}</div>
              <div className="text-sm text-gray-600">Engine Version</div>
            </div>
          </>
        )}
      </div>
      
      {FEATURE_FLAGS.AI_SELECTION && (
        <div className="mt-4 p-3 bg-indigo-50 rounded-lg">
          <div className="flex items-center space-x-2">
            <span className="text-indigo-600">✨</span>
            <span className="text-sm text-indigo-800">
              AI enhancements include adaptive difficulty, follow-up questions, and personalized insights
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default EnhancementStats;